export default {
  allProducts: {
    id: 'all_product_lowercase',
    defaultMessage: 'all refurbished products',
  },
  goBack: {
    id: 'review_display_goback_product',
    defaultMessage: 'Go back to the product',
  },
  popularSearches: {
    id: 'popular_search',
    defaultMessage: 'Popular searches',
  },
  seeMore: {
    id: 'review_page_see_more',
    defaultMessage: 'See more',
  },
  seoText: {
    id: 'review_display_seo_text',
    defaultMessage:
      "Is Back Market a reliable website? Can Back Market be trusted? Are the items sold of good quality? What is the meaning of life? Are we alone in the universe? What is the airspeed velocity of an unladen swallow?So many questions so little time. But we'll try to answer (at least the vital ones) here.",
  },
  seoTextHiddenPart: {
    defaultMessage:
      "Back Market is a marketplace. By definition, we connect our sellers with end customers via our website. The quality of the refurbished products sold on Back Market is therefore dependent on the quality of the sellers themselves. Our goal is to ensure that they always provide an incredible level of service. To achieve this, we subject all high-tech device refurbishing plants to our most stringent selection processes, which takes into account all relevant criteria: quality of diagnosis, responsiveness of customer service, delivery times, etc. But that's not enough: our sales partners must also comply with a set of very strict specifications before they can sell on our website. As a result, we're able to guarantee that the refurbished smartphones, laptops, and other products that you buy from us will be just as functional as a unit sold new.But you don't have to just take our word for it. Rather, go and see for yourself how our main partners are giving used electronic products a second life {link, html}. If you still need a little more convincing, don't hesitate to check out our other customer reviews in the section below. For any other questions... Google it.",
    id: 'review_display_seo_text_hidden_part',
  },
  soundAndFurious: {
    id: 'sound_and_furious',
    defaultMessage: '"The sound and the fury"',
  },
  titleMerchant: {
    id: 'review_display_page_title_merchant_new',
    defaultMessage: "{merchant}'s customer reviews",
  },
  titleProduct: {
    id: 'review_display_page_title_product',
    defaultMessage: "{productName}'s customer reviews",
  },
  titleNeutral: {
    id: 'review_display_page_title_neutral',
    defaultMessage: 'Customer reviews for',
  },
  aboutUs: {
    id: 'review_display_about_us',
    defaultMessage: 'About Us',
  },
  rateDescription: {
    id: 'review_display_rate_description',
    defaultMessage: `{totalReviews, number} {totalReviews, plural,
      one {purchase}
      other {purchases}
    } in the last 6 months.`,
  },
}
